import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=652a7780&scoped=true&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&id=652a7780&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652a7780",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('652a7780')) {
      api.createRecord('652a7780', component.options)
    } else {
      api.reload('652a7780', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=652a7780&scoped=true&", function () {
      api.rerender('652a7780', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/worldcup/detail.vue"
export default component.exports